import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import UserContext from "./context/UserContext";
import { createRoot } from 'react-dom';
import { ToastContainer } from 'react-toastify';

import reportWebVitals from "./reportWebVitals";

const root = document.getElementById("root");

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <UserContext>
      <BrowserRouter>
      <ToastContainer />
        <App />
      </BrowserRouter>
    </UserContext>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
